import styled from 'styled-components'
import { Box, theme, Grid } from '@dasa-health/components-react'

export const Container = styled.div`
    width: 100vw;
    margin: 0 auto;
    padding: 2rem 0;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: calc(100vw - 150px);
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        max-width: 54.5rem;
    }
`

export const TopicBox = styled(Grid)`
    padding: 1rem;
    margin-top: 30px !important;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        padding: 0 1rem;
        margin-top: 50px !important;
    }
`
export const PrincipalBox = styled(Grid)`
    padding: 0 2rem;
    margin-top: 0 !important;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        margin-top: 3rem !important;
        padding: 0 1rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        padding: 0 1rem;
        margin-top: 5rem !important;
    }
`

export const BoxTexts = styled(Box)`
    max-width: 36rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 44rem) {
        max-width: 18rem;
    }

    @media screen and (max-width: 20rem) {
        max-width: 20rem;
    }
`

export const Title = styled.h1`
    font-size: 2.5rem;
    font-weight: 300;
    line-height: 3rem;
    text-align: left;
    color: #fefefe;

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        font-size: 2.5rem;
        line-height: 3rem;
    }

    @media screen and (max-width: ${theme.breakpoints[1]}) {
        font-size: 2rem;
        line-height: 2.5rem;
    }
`

export const SubTitle = styled.p`
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    text-align: left;
    padding-top: 1rem;
    color: #e9e9e9;
`

export const Img = styled.img`
    width: 100%;
    max-width: 23.625rem;
    min-width: 8.125rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: 12.813rem;
        float: right;
    }

    @media screen and (min-width: 45rem) {
        position: relative;
        min-width: 80%;
        top: 2.375rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 100%;
        min-width: 25rem;
    }
`

export const ButtonsBox = styled(Box)`
    display: flex;
    gap: 1.5rem;
    padding: 2rem 2rem 0.5rem;
    align-items: center;
    justify-content: space-between;
    width: 27rem;

    a {
        flex: 1;
        display: inherit;
    }

    button {
        flex: 1;
        font-size: 1rem;
        height: 3rem;
        width: 100%;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        padding: 2rem 1rem 0.5rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        padding: 2rem 1rem 0.5rem;
    }

    @media screen and (max-width: 27rem) {
        flex-direction: column;
        align-items: inherit;
        width: 100%;
    }
`
